import React from "react";
import { Outlet, useLocation } from "react-router-dom";

/**
 * Keeps the list page mounted so add/edit/view forms can overlay as EMS side drawers.
 * Personalize View is a full page, so the list is hidden on that route.
 */
export default function ListWithDrawerOutlet({ children }) {
  const location = useLocation();
  const hideList = /\/personalize-view\/?$/.test(location.pathname);

  return (
    <>
      {!hideList && children}
      <Outlet />
    </>
  );
}
